var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 1.2c-23 1.9-50.2 9.3-69 18.8-13 6.5-20.4 11.4-32.4 21.3-27.5 22.6-46.1 53.3-52.7 86.6-1.8 9.4 1.2 17 8.1 20.6 4 2 49.9 7.8 58.1 7.2 12.8-.8 21.7-8.1 28.4-23.4 11-25 24.4-39.4 45.8-49.3 15.6-7.2 35-10.2 53.5-8.2 14.9 1.6 22.1 3.6 33.7 9.3 23.3 11.3 37.1 31.3 38.3 55.2.7 14.3-2 24.5-9.5 36.4-4.7 7.5-13.7 16-41.3 39.2-49.5 41.6-66.4 61.1-74.9 86.6-4.1 12.5-5.9 21.8-7.3 37.5-1 11.8-.9 14.2.5 19 3.1 10.4 11 18.2 21.7 21.4 7.3 2.2 35.4 2.3 42.6.1 14.2-4.2 21.8-14.5 23.9-32.5 2.9-24.3 9.7-33.4 51.9-69.9 42.4-36.6 64-59.8 74.4-79.7 24.4-47 13.8-103.8-26.8-144.4-17.9-17.9-35.8-29.6-59.3-38.9C308.9 2.7 268.6-2.1 230 1.2zM231 415.9c-8.7 2.7-16.5 9.5-20.4 18-2 4.3-2.1 6.2-2.1 29.6 0 24.5 0 25.1 2.4 30 3.2 6.3 9.3 12.4 15.6 15.5 4.6 2.3 6.4 2.5 22 2.9 11.1.2 18.9-.1 22.5-.9 6.7-1.5 14.8-6.7 18.3-11.8 5.7-8.2 6.1-10.2 6.5-32.1.5-28.7-1.3-36.3-11.1-44.6-7.5-6.4-12.3-7.5-33-7.4-10 0-19.3.4-20.7.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ed624540.svg";
export { ForwardRef as ReactComponent };